import { render, staticRenderFns } from "./AppProductSearch.vue?vue&type=template&id=0f704902"
import script from "./AppProductSearch.vue?vue&type=script&lang=js"
export * from "./AppProductSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports